import React from 'react'
import { theme } from '../../../../../../../Assets/Styles/theme'

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '24px',
  },
  circlesContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '8px',
  },
  labelsContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  stepCircle: (isActive, isCompleted) => ({
    width: '24px',
    height: '24px',
    borderRadius: '50%',
    border: `2px solid ${isActive ? theme.colors.primary : '#E2E2FC'}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.3s ease',
    backgroundColor: isCompleted ? theme.colors.primary : 'white',
  }),
  completedIndicator: {
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    backgroundColor: 'white',
  },
  stepLabel: (isActive, isCompleted) => ({
    fontSize: '14px',
    fontWeight: isActive ? '600' : '400',
    color: isActive
      ? theme.colors.primary
      : isCompleted
      ? '#E2E2FC'
      : '#A0A0A0',
    fontFamily: 'Proxima Nova',
    textAlign: 'center',
    transition: 'all 0.3s ease',
    width: '80px',
    textDecoration: isCompleted ? 'line-through' : 'none',
  }),
  connectorLine: isCompleted => ({
    width: '80px',
    height: '2px',
    backgroundColor: isCompleted ? theme.colors.primary : '#E2E2FC',
    transition: 'background-color 0.3s ease',
  }),
}

const StepsIndicator = ({ currentStep = 1 }) => {
  const steps = [{ id: 1, label: 'Basic Info' }, { id: 2, label: 'Scheduling' }]

  return (
    <div style={styles.container}>
      {/* Circles and connector lines row */}
      <div style={styles.circlesContainer}>
        {steps.map((step, index) => (
          <React.Fragment key={step.id}>
            {/* Step Circle */}
            <div
              style={styles.stepCircle(
                currentStep >= step.id,
                currentStep > step.id,
              )}
            />

            {/* Connector Line */}
            {index < steps.length - 1 && (
              <div style={styles.connectorLine(currentStep > step.id)} />
            )}
          </React.Fragment>
        ))}
      </div>

      {/* Labels row */}
      <div style={styles.labelsContainer}>
        {steps.map((step, index) => (
          <React.Fragment key={`label-${step.id}`}>
            <span
              style={styles.stepLabel(
                currentStep >= step.id,
                currentStep > step.id,
              )}
            >
              {step.label}
            </span>
            {/* Spacer for alignment with connector line */}
            {index < steps.length - 1 && <div style={{ width: '30px' }} />}
          </React.Fragment>
        ))}
      </div>
    </div>
  )
}

export default StepsIndicator
